<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">

    <section id="header">
      <div fxLayout="row" fxLayoutAlign="start center">
        <h1 class="h1Header">HOLA!</h1>
        <h1 class="second h1Header">{{store.dsName}}</h1>
      </div>
    </section>
    <section id="body">
      <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="1rem">

        <mat-card class="stat-card">
          <mat-icon class="fastfood">fastfood</mat-icon>
          <p class="stat-header">Item totales</p>
          <p>{{totalItems}}</p>
        </mat-card>

        <mat-card class="stat-card">
          <mat-icon class="shopping_cart">shopping_cart</mat-icon>
          <p class="stat-header">Órdenes del mes</p>
          <p>{{lastMonthOrdersQty}}</p>
        </mat-card>

      </div>
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <mat-card class="buttonCard">
          <button fxFlex="12" class="chart-btn" mat-raised-button (click)="getTodaysOrders()">Hoy</button>
          <button fxFlex="13" class="chart-btn" mat-raised-button (click)="getYesterdaysOrders()">Ayer</button>
          <button fxFlex="14" class="chart-btn" mat-raised-button (click)="getLastWeekOrders()">Últimos 7
            días</button>
          <button fxFlex="15" class="chart-btn" mat-raised-button (click)="getLastMonthOrders()">Últimos 30
            días</button>
          <button fxFlex="13" class="chart-btn" mat-raised-button (click)="getThisMonthOrders()">Este mes</button>
          <button fxFlex="14" class="chart-btn" mat-raised-button (click)="getPreviousMonthOrders()">Mes pasado</button>
          <button fxFlex="17" class="chart-btn" mat-raised-button (click)="getLastSixMonthsOrders()">Últimos 6
            meses</button>
        </mat-card>
      </div>
      <div style="display: block;">
        <mat-card>
          <div fxLayout="row" fxLayoutAlign="center center">
            <h3 *ngIf="!showChart" class="cardHeader">Seleccionar fecha para mostrar reportes</h3>
          </div>
          <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="showChart">
            <h3 class="cardHeader">Reporte de ventas: {{title}}</h3>
            <button mat-icon-button>
              <mat-icon class="refresh-icon" (click)="refreshData()">refresh</mat-icon>
            </button>
          </div>
          <canvas baseChart [data]="pieChartData" [labels]="pieChartLabels" [chartType]="pieChartType"
            [options]="pieChartOptions" [plugins]="pieChartPlugins" [legend]="pieChartLegend" [colors]="pieChartColors"
            *ngIf="showChart">
          </canvas>
        </mat-card>
      </div>

    </section>
  </div>
</div>
